import { apiRequest } from "@/services/api-client";
import { DeleteItemDeckInput, DeleteItemDeckOutput, WebAppRoutes } from "types/web-app";

export const deleteItemDeck = (input: DeleteItemDeckInput) =>
  apiRequest<DeleteItemDeckOutput>("/" + WebAppRoutes.DELETE_ITEM_DECK, {
    method: "POST",
    body: JSON.stringify(input),
  });
